import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { ActiveUserService } from '../../services/active-user.service';

@Component({
  selector: `app-navbar`,
  templateUrl: `./navbar.component.html`,
  styleUrls: [ `./navbar.component.scss` ],
  imports: [
    AsyncPipe,
    NzAvatarModule,
    NzMenuModule,
    RouterLink,
  ],
})
export class NavbarComponent {
  public activeUserService: ActiveUserService = inject(ActiveUserService);
  public authService: AuthService = inject(AuthService);

  public activeUser$ = this.activeUserService.getActiveUser$();

  onLogoutClick(): void {
    this.authService.logout({ logoutParams: { returnTo: document.location.origin } });
  }

}
